import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { useApp } from '../../context/AppContext';
import Sidebar from './Sidebar';
import { Toaster } from '../ui/sonner';

const MainLayout = () => {
  const { user, loading } = useApp();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="flex flex-col items-center gap-4">
          <div className="w-12 h-12 border-4 border-primary border-t-transparent rounded-full animate-spin" />
          <p className="text-muted-foreground font-mono text-sm">Loading...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div className="min-h-screen bg-background flex">
      <Sidebar />
      <main className="flex-1 min-w-0 min-h-screen lg:ml-0 relative overflow-x-hidden">
        {/* ambient arcade glow */}
        <div className="pointer-events-none fixed inset-0 -z-0 opacity-70"
          style={{ background: 'radial-gradient(50% 40% at 100% 0%, hsl(var(--secondary) / 0.06), transparent 60%), radial-gradient(45% 35% at 0% 3%, hsl(var(--primary) / 0.06), transparent 60%)' }} />
        <div className="relative z-10 w-full max-w-full p-4 lg:p-8 pt-16 lg:pt-8">
          <Outlet />
        </div>
      </main>
      <Toaster richColors duration={2000} position="top-center" />
    </div>
  );
};

export default MainLayout;